// Algunos celulares (modo "sitio de escritorio", ciertos navegadores o WebViews)
// muestran los inputs de fecha/hora como casillas editables (hh : mm a.m.) en vez
// de abrir el reloj/calendario al tocarlos. Ahí el usuario solo ve un segmento
// resaltado y no puede hacer nada. Forzamos la apertura del selector nativo con
// showPicker() al hacer clic, así funciona igual en todos los dispositivos.
const PICKER_TYPES = ['time', 'date', 'datetime-local', 'month', 'week'];

export function installPickerFix() {
  // Fase de captura: se ejecuta antes que cualquier onClick, así un modal que haga
  // stopPropagation() no impide que el selector se abra.
  document.addEventListener('click', (e) => {
    const el = e.target;
    if (!(el instanceof HTMLInputElement)) return;
    if (!PICKER_TYPES.includes(el.type) || el.disabled || el.readOnly) return;
    if (typeof el.showPicker !== 'function') return;
    try {
      el.showPicker();
    } catch {
      // Navegador sin soporte o selector ya abierto: se deja el comportamiento normal.
    }
  }, true);
}
